export default function isMobile() {
	return window.innerWidth < 600;
}

export function isTablet() {
	return window.innerWidth < 960;
}

export function isTouchable() {
	return (
		"ontouchstart" in window ||
		navigator.maxTouchPoints > 0 ||
		navigator.msMaxTouchPoints > 0
	);
}
